var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchingOutputPreset || _vm.fetchingEmptyOutputPreset)?_c('loading-page'):_c('output-preset-form',{attrs:{"submit-loading":_vm.creatingOutputPreset,"duplicating":_vm.duplicating},on:{"submit":_vm.createOutputPreset}})}
var staticRenderFns = []

export { render, staticRenderFns }